import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss']
})
export class HealthCheckComponent implements OnInit {
  loading: boolean = true;
  healthList: any[] = [];
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchHealthStatus();
    //setInterval(() => this.fetchHealthStatus(), 30000); // Atualiza a cada 30s
  }

  fetchHealthStatus(): void {
    this.loading = true;


    this.http.get<any>(`${environment.apiUrl}/health/checkall` ).subscribe(
      (response) => {
        this.healthList = response;
        this.loading = false;
        console.log(response);

      },
      (error) => {
        console.error('Error:', error);
      });
  }

  getStatusIcon(status: boolean): string {
    return status === true ? '✅' : '❌';
  }
}
